<template>
  <modal
    :show="showNewDestinationModal"
    modal-classes="modal-dialog-centered modal-sm"
    @close="closeDestinationModal('close')"
    no-close-on-backdrop
  >
    <template slot="header">
      <h4 class="subtitle">
        Assign destination
      </h4>
    </template>
    <div class="mt-4">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <WSelect
            v-bind:class="{
              'is-invalid': $v.branch.destination.slug.$error
            }"
            placeholder="Select Destination"
            v-model="destinationId"
            id="destination"
            name="destination"
            filterable
            @change="selectDestination"
            label="Destination"
            markrequired
            :error="
              $v.branch.destination.slug.$error ? `Enter Destination` : ''
            "
          >
            <el-option
              v-for="(destination, index) in destinationsOptions"
              :value="destination._id"
              :label="destination.city"
              :key="index"
              :disabled="isAssignment(destination)"
            >
              <span class="hide-data-inline coin-left">{{
                destination.city
              }}</span>
              <span class="hide-data-inline coin-right">{{
                destination.country.name
              }}</span>
            </el-option>
          </WSelect>
        </div>

        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <BaseNumberInput
            v-model.number="$v.branch.selection_range.$model"
            id="selection_range"
            name="selection_range"
            label="Service Coverage Radius"
            placeholder="Service Coverage Radius"
            markrequired
            :error="
              $v.branch.selection_range.$error
                ? `Enter from 5Km and to 250Km`
                : ''
            "
          />
        </div>
      </div>
    </div>

    <template slot="footer">
      <base-button
        type="outline-neutral mb-0"
        class="min-button"
        @click="closeDestinationModal('close')"
        ><i class="flaticon-cancel"></i>Cancel</base-button
      >
      <base-button
        type="primary"
        class="min-button ml-auto mb-0"
        @click="saveDestination"
        ><i class="flaticon-floppy-disk"></i> Save</base-button
      >
    </template>
  </modal>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import { BranchesAPI } from "../../../../core/api";
import { required, numeric } from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
import lodash from "lodash";
import { handleApiError } from "../../../../core/services";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "NewDestinations",
  components: {
    WSelect
  },
  props: {
    supplierId: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    },
    destinations: {
      type: Array,
      default: () => []
    },
    assignments: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showNewDestinationModal: false,
      destinationsOptions: [],
      branch: {
        name: "",
        supplier: this.supplierId,
        country_code: "",
        timezone: "",
        geometry: {},
        selection_range: 45,
        destination: {
          uuid: "",
          city: "",
          country: {},
          languages: [],
          location: {},
          slug: "",
          state: {},
          time_zone: "",
          iata_code: "",
          geometry: {
            type: "Polygon",
            coordinates: []
          },
          article: {
            description: "",
            thumbnail: "",
            image: ""
          },
          exceptions: []
        }
      },
      selects_hours: [1, 5, 10, 15, 24, 36, 48],
      cancelationsOptions: [1, 12],
      destinationId: null
    };
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showNewDestinationModal = current;
      },
      deep: true
    },
    destinations: {
      handler: function(current, old) {
        this.destinationsOptions = current;
      },
      deep: true
    }
  },
  async created() {
    this.destinationsOptions = this.destinations;
    this.cancelationsOptions = this.cancelationsOptions.concat(
      Array.from({ length: 30 }, (_, index) => (index + 1) * 24)
    );
  },
  methods: {
    handleError(error, message) {
      handleApiError(this, error, message);
    },
    async saveDestination() {
      if (!this.$v.branch.$invalid) {
        if (!this.isAssignment(this.branch.destination)) {
          let branch = lodash.cloneDeep(this.branch);
          await this.createDestination(branch);
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "This destination was previously assigned",
            icon: "flaticon-warning-1"
          });
        }
      } else {
        this.$v.branch.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async createDestination(branch) {
      try {
        this.setLoad(true);
        let { data } = await BranchesAPI.createBranch(
          branch,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Destination has been saved",
            icon: "flaticon-check-3"
          });
          this.closeDestinationModal("created");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error saving the Destination, please try again"
        );
      }
    },
    selectDestination(destinationId) {
      let destination = this.destinationsOptions.find(
        destination => destination._id === destinationId
      );
      if (destination) {
        this.branch.name = destination.city;
        this.branch.supplier = this.supplierId;
        this.branch.country_code = destination.country.code;
        this.branch.timezone = destination.time_zone;
        this.branch.geometry.location = destination.location;
        this.branch.destination.uuid = destination.uuid;
        this.branch.destination.city = destination.city;
        this.branch.destination.country = destination.country;
        this.branch.destination.exceptions = destination.exceptions;
        this.branch.destination.iata_code = destination.iata_code;
        this.branch.destination.languages = destination.languages;
        this.branch.destination.location = destination.location;
        this.branch.destination.slug = destination.slug;
        this.branch.destination.state = destination.state;
        this.branch.destination.time_zone = destination.time_zone;
        this.branch.destination.article = {
          description: destination.article
            ? destination.article.description
            : "",
          thumbnail: destination.article ? destination.article.thumbnail : "",
          image: destination.article ? destination.article.image : ""
        };
        this.branch.destination.geometry = {
          type: "Polygon",
          coordinates: []
        };
      }
    },
    closeDestinationModal(action = "close") {
      this.showNewDestinationModal = false;
      this.restartData();
      this.$emit("close", action);
    },
    restartData() {
      this.branch = {
        name: "",
        supplier: this.supplierId,
        country_code: "",
        timezone: "",
        geometry: {},
        selection_range: 45,
        destination: {
          uuid: "",
          city: "",
          country: {},
          languages: [],
          location: {},
          slug: "",
          state: {},
          time_zone: "",
          iata_code: "",
          geometry: {
            type: "Polygon",
            coordinates: []
          },
          article: {
            description: "",
            thumbnail: "",
            image: ""
          },
          exceptions: []
        }
      };
      this.destinationId = null;
      this.$v.branch.$reset();
    },
    getTimeFormat(time) {
      if (time >= 1 && time <= 12) {
        return time === 1 ? `${time} hour` : `${time} hours`;
      } else {
        return time / 24 === 1 ? `${time / 24} day` : `${time / 24} days`;
      }
    },
    isAssignment(destination) {
      let isAssignment = this.assignments.find(
        assignment =>
          assignment.slug == destination.slug &&
          assignment.country.code === destination.country.code
      );
      return isAssignment ? true : false;
    },
    ...mapMutations(["setSigOut", "setLoad"]),
    ...mapActions([])
  },
  computed: {
    ...mapGetters(["sesion"])
  },
  validations: {
    branch: {
      destination: {
        slug: {
          required
        }
      },
      selection_range: {
        required,
        numeric,
        customValidator: function(value) {
          return value >= 5 && value <= 250;
        }
      }
    }
  }
};
</script>
